import React from 'react';
import TextCell from 'app/components/data-table/TextCell';
import ChangelogDateCell from './ChangelogDateCell';
import RevisionEnabledCell from './RevisionEnabledCell';
import RevisionNotesCell from './RevisionNotesCell';
import UserCell from './UserCell';

const changelogTableColumns = [
  {
    id: 'revision',
    name: 'Revision',
    selector: row => row.revision,
    cell: row => <TextCell text={String(row.revision)} />,
    sortable: true,
    width: '128px',
  },
  {
    id: 'commitMessage',
    name: 'Revision Notes',
    cell: row => <RevisionNotesCell playbook={row} />,
    wrap: true,
  },
  {
    id: 'createdBy',
    name: 'User',
    cell: row => <UserCell user={row.createdBy} />,
    width: '192px',
  },
  {
    id: 'createdAt',
    name: 'Date',
    selector: row => row.createdAt,
    cell: row => <ChangelogDateCell createdAt={row.createdAt} />,
    sortable: true,
    width: '224px',
  },
  {
    id: 'enabled',
    name: 'Enabled',
    cell: row => <RevisionEnabledCell playbook={row} />,
    center: true,
    width: '112px',
  },
];

export default changelogTableColumns;
